import axios from 'axios';
import {
    MDBAccordion,
    MDBAccordionItem,
    MDBBtn,
    MDBBtnGroup,
    MDBCardHeader,
    MDBCheckbox,
    MDBCol,
    MDBIcon,
    MDBInput,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
    MDBSelect,
    MDBTextArea,
    MDBTypography
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DomainContext } from '../context/DomainProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import Upload from '../reusables/Upload';
const FeedbackAccordion = ({ removeImpact, feature, featureIndex,index, handleChange, isEdit, addImpact, setActiveAccordions, demoUser, addFeedback, handleCheckboxChange, addCheckbox, removeCheckbox, handleCheckboxLabelChange, addQuestion, removeFeedback,demoId,
    removeQuestion, handleFeedbackUserChange,handleUpdateForNonLoggedinFeedBackUser,setFormData,
    handleQuestionInputChange,setCentredModal,
    handleAnswerInputChange }) => {
        const {domainId,firmId,} = useContext(DomainContext);
        const [categories, setCategories] = useState([]);
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [newCategory, setNewCategory] = useState('');
        const toggleModal = () => setIsModalOpen(!isModalOpen);
        const baseUrl = process.env.REACT_APP_INVENTORY_URL;
        useEffect(() => {
            // Fetch categories when the component mounts
            fetchCategories();
        }, []);
    
      
    
        const fetchCategories = async () => {
            try {
                let url = `${baseUrl}/categories/static/domain/${domainId}`;
                const response = await axios.get(url);
                // Transform categories to ensure proper structure
                const transformedCategories = response.data.map(cat => ({
                    text: cat.text || 'Unnamed Category', // Fallback if text is null or missing
                    value: cat.value || cat.id // Fallback to cat.id if value is null or missing
                }));
                setCategories(transformedCategories);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
    
        const handleAddCategory = async () => {
            try {
                let url = `${baseUrl}/categories/static`;
                const response = await axios.post(url, { text: newCategory, value: newCategory ,id:uuidv4(),domainId:domainId, firmId:firmId ||domainId});
                // Add the new category to the state after transforming it
                const newCat = {
                    text: response.data.text || 'Unnamed Category',
                    value: response.data.value || response.data.id,
                    id: response.data.id,
                };
                setCategories([...categories, newCat]);
                setNewCategory('');
                setIsModalOpen(false);
            } catch (error) {
                console.error('Error adding category:', error);
            }
        };

     
    const toggleAccordion = (feedbackIndex) => {

        setActiveAccordions((prev) => ({
            ...prev,
            [index]: prev[index] === feedbackIndex ? null : feedbackIndex,
        }));

        // Scroll into view when accordion is opened
  const accordionElement = document.getElementById(`feedback-item-${feedbackIndex}`);
  if (accordionElement) {
    accordionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
    };
const scrollToFeedback = () => {
  const feedbackSection = document.getElementById('feedback-section');
  if (feedbackSection) {
    feedbackSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const moveQuestionUp = (feedbackIndex, questionIndex) => {
    setFormData((prevFormData) => {
        const updatedFormData = JSON.parse(JSON.stringify(prevFormData));
        const questions = updatedFormData.orchestration[index].feedbacks[feedbackIndex].questions;

        if (questionIndex > 0) {
            // Swap the question with the previous one
            [questions[questionIndex - 1], questions[questionIndex]] = [questions[questionIndex], questions[questionIndex - 1]];
        }

        return updatedFormData;
    });
};

const moveQuestionDown = (feedbackIndex, questionIndex) => {
    setFormData((prevFormData) => {
        const updatedFormData = JSON.parse(JSON.stringify(prevFormData));
        const questions = updatedFormData.orchestration[index].feedbacks[feedbackIndex].questions;

        if (questionIndex < questions.length - 1) {
            // Swap the question with the next one
            [questions[questionIndex], questions[questionIndex + 1]] = [questions[questionIndex + 1], questions[questionIndex]];
        }

        return updatedFormData;
    });
}; 

const moveQuestionToTop = (feedbackIndex, questionIndex) => {
    setFormData((prevFormData) => {
        const updatedFormData = JSON.parse(JSON.stringify(prevFormData));
        const questions = updatedFormData.orchestration[index].feedbacks[feedbackIndex].questions;

        if (questionIndex > 0) {
            // Remove the question from its current position
            const [movedQuestion] = questions.splice(questionIndex, 1);
            // Add it to the beginning of the array
            questions.unshift(movedQuestion);
        }

        return updatedFormData;
    });
};

const moveQuestionToBottom = (feedbackIndex, questionIndex) => {
    setFormData((prevFormData) => {
        const updatedFormData = JSON.parse(JSON.stringify(prevFormData));
        const questions = updatedFormData.orchestration[index].feedbacks[feedbackIndex].questions;

        if (questionIndex < questions.length - 1) {
            // Remove the question from its current position
            const [movedQuestion] = questions.splice(questionIndex, 1);
            // Add it to the end of the array
            questions.push(movedQuestion);
        }

        return updatedFormData;
    });
};


const { tokenLoaded } = useContext(UserProfileContext);
    const [activeIndex, setActiveIndex] = useState(0); // State to track the active slide

    // Handle manual slide change
    const handleSlideChange = (newIndex) => {
        setActiveIndex(newIndex);
    };
    const groupQuestionsByCategory = (items) => {
        return items.reduce((acc, current) => {
            const category = current.category || 'Uncategorized';
            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(current);
            return acc;
        }, {});
    };
    const getFeatureByPath = (orchestration, indexPath) => {
        // Convert indexPath to a string to handle multi-level paths
        const pathArray = typeof indexPath === 'string' && indexPath.includes('-')
          ? indexPath.split('-').map((i) => parseInt(i, 10))
          : [parseInt(indexPath, 10)];
      
        let targetFeature = orchestration[pathArray[0]];
      
        // Traverse sub-features using the path array
        for (let i = 1; i < pathArray.length; i++) {
          if (targetFeature && targetFeature.subFeatures) {
            targetFeature = targetFeature.subFeatures[pathArray[i]];
          } else {
            // Return null if the path is invalid or incomplete
            console.warn(`Invalid path at index ${pathArray[i]} in path ${indexPath}`);
            return null;
          }
        }
      
        return targetFeature;
      };
      
      
    // Assuming `feature.painPromise` is an array of objects with a category property
    const groupedQuestions = groupQuestionsByCategory(feature.painPromise || []);
    // const handleImageUpload = (imageUrl, feedbackIndex) => {
    //     setFormData((prevState) => {
    //         const updatedFormData = JSON.parse(JSON.stringify(prevState)); // Deep copy of formData
    //         // Update the imageUrl for the specific feedback user
    //         getFeatureByPath(updatedFormData.orchestration).feedbacks[feedbackIndex].feedbackUser.imageUrl = imageUrl;
    //         return updatedFormData;
    //     });
    // };
  
    
    const handleImageUpload = (imageUrl, feedbackIndex) => {
        setFormData((prevState) => {
          // Safe deep clone for `formData`
          const updatedFormData = structuredClone(prevState);
      
          // Attempt to retrieve the feature at the specified path
          const targetFeature = getFeatureByPath(updatedFormData.orchestration, featureIndex);
      
          if (targetFeature) {
            // Initialize `feedbacks` if not present
            const feedbacks = targetFeature.feedbacks || [];
            targetFeature.feedbacks = feedbacks;
      
            // Ensure `feedbackIndex` is within bounds of `feedbacks`
            if (feedbackIndex < feedbacks.length && feedbacks[feedbackIndex]) {
              // Initialize `feedbackUser` if not present
              const feedbackUser = feedbacks[feedbackIndex].feedbackUser || {};
              feedbacks[feedbackIndex].feedbackUser = feedbackUser;
      
              // Safely set the image URL
              feedbackUser.imageUrl = imageUrl;
            } else {
              console.warn(`Feedback index ${feedbackIndex} is out of bounds.`);
            }
          } else {
            console.warn(`Feature at path ${featureIndex} not found.`);
          }
      
          return updatedFormData;
        });
      };
      
     
      
    return (
        <MDBAccordion initialActive={1} className='container-xl'
            onSlide={(newIndex) => handleSlideChange(newIndex)}
            activeItem={activeIndex}
        >
            {feature.feedbacks.map((feedback, feedbackIndex) => (
        <MDBAccordionItem
                collapseId={`${featureIndex}-${feedbackIndex + 1}`}
                    headerTitle={
                        <MDBTypography variant="h6" tag="span">
                            Feedback from <strong className='text-black'>{feedback?.feedbackUser?.firstName || ''} {feedback?.feedbackUser?.lastName || ''}</strong>
                        </MDBTypography>

                    }
                    key={`${featureIndex}-${feedbackIndex}`} 
                    onClick={() => toggleAccordion(feedbackIndex)}
                >
                    <div className='text-center'>
                        { (feedback.isNew || isEdit) ? (
                            <div className="mb-2 ms-2 me-2 align-items-center justify-content-center">
                                <MDBCardHeader className="fs-1">Contact Info</MDBCardHeader>
                                {/* <img
                                    className="rounded-circle shadow-1 mb-3"
                                    src={feedback?.feedbackUser?.imageUrl || "https://mdbootstrap.com/img/new/avatars/1.jpg"}
                                    alt="avatar"
                                    style={{ width: "150px" }}
                                /> */}
{tokenLoaded  && 
<MDBRow className="text-center align-items-center justify-content-center">
      <MDBCol> <img
        className="rounded-circle shadow-1 mb-3 "
        src={feedback?.feedbackUser?.imageUrl|| "https://mdbootstrap.com/img/new/avatars/1.jpg"}
        alt="avatar"
        style={{ width: "150px" }}
        />
      </MDBCol>
      <MDBCol>         <Upload 
            documentType={'image'} 
            onImageUpload={(imageUrl) => handleImageUpload(imageUrl, feedbackIndex)} 
        />
    </MDBCol>
   
  
    </MDBRow>}


                                <MDBRow className="mb-2">
                                    <MDBCol xs="12" md="6">
                                        <MDBInput
                                            label="First name"
                                            name="firstName"
                                            value={feedback.feedbackUser?.firstName || ''}
                                            onChange={(e) => handleFeedbackUserChange('firstName', e.target.value, featureIndex, feedbackIndex)}
                                        />
                                    </MDBCol>
                                    <MDBCol xs="12" md="6">
                                        <MDBInput
                                            label="Last name"
                                            name="lastName"
                                            value={feedback.feedbackUser?.lastName || ''}
                                            onChange={(e) => handleFeedbackUserChange('lastName', e.target.value, featureIndex, feedbackIndex)}
                                        />
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow className="mb-2">
                                    <MDBCol xs="12" md="6">
                                        <MDBInput
                                            label="Company name"
                                            name="companyName"
                                            value={feedback.feedbackUser?.companyName || ''}
                                            onChange={(e) => handleFeedbackUserChange('companyName', e.target.value, featureIndex, feedbackIndex)}
                                        />
                                    </MDBCol>
                                    <MDBCol xs="12" md="6">
                                        <MDBInput
                                            label="Role"
                                            name="role"
                                            value={feedback.feedbackUser?.role || ''}
                                            onChange={(e) => handleFeedbackUserChange('role', e.target.value, featureIndex, feedbackIndex)}
                                        />
                                    </MDBCol>
                                </MDBRow>
                                <MDBInput
                                    label="Website"
                                    wrapperClass='mb-2'
                                    name="webSiteUrl"
                                    value={feedback.feedbackUser?.webSiteUrl || ''} 
                                    onChange={(e) => handleFeedbackUserChange('webSiteUrl', e.target.value, featureIndex, feedbackIndex)}
                                />
                                <MDBInput
                                    label="Email"
                                    wrapperClass='mb-2'
                                    name="email"
                                    value={feedback.feedbackUser?.email || ''}
                                    onChange={(e) => handleFeedbackUserChange('email', e.target.value, featureIndex, feedbackIndex)}
                                />
                                <MDBInput
                                    label="Phone"
                                    wrapperClass='mb-2'
                                    name="phone"
                                    value={feedback.feedbackUser?.phone || ''}
                                    onChange={(e) => handleFeedbackUserChange('phone', e.target.value, featureIndex, feedbackIndex)}
                                />

                                <MDBInput
                                    wrapperClass='mb-2'
                                    id='form6FeedbackUrserImageUrl7'
                                    label='Avatar'
                                    name='imageUrl'
                                    value={feedback.feedbackUser?.imageUrl || ''}
                                    onChange={(e) => handleFeedbackUserChange('imageUrl', e.target.value, featureIndex, feedbackIndex)}
                                />

                            </div>
                        ) : (
                           

<MDBRow className="text-center align-items-center justify-content-center">
      <MDBCol>  <div >
                                <div className="text-center">
                                    <img    
                                        className="rounded-circle shadow-1 mb-3"
                                        src={feedback?.feedbackUser?.imageUrl || "https://mdbootstrap.com/img/new/avatars/1.jpg"}
                                        alt="avatar"
                                        style={{ width: "150px" }}
                                    />
                                    <p className="mb-1">
                                        <strong>{`${feedback.feedbackUser?.firstName || 'Anonymous'} ${feedback.feedbackUser?.lastName || ''}`}</strong>
                                    </p>
                                    <p className="mb-2">
                                        <small>{feedback.feedbackUser?.role || 'N/A'}</small>
                                    </p>
                                    
                                </div>
                            </div>
      </MDBCol>
   {feedback.isNew &&   <MDBCol>         <Upload 
            documentType={'image'} 
            onImageUpload={(imageUrl) => handleImageUpload(imageUrl, feedbackIndex)} 
        />
    </MDBCol>
    }
   
  
    </MDBRow>




                        )}
                        <div className='mt-2 align-items-center justify-content-center'>
                            <MDBCardHeader className='fs-4'> {(isEdit|| feedback.isNew) ? 'How does it impact you?': 'Impact on Me'}</MDBCardHeader>
                            {feedback?.impactsOnYourBusiness?.map((impact, impactIndex) => (
                                (tokenLoaded || feedback.isNew)? <MDBBtnGroup key={impactIndex} className='d-flex mx-2 my-2'>

                                    <MDBTextArea
                                        wrapperClass='flex-grow-1'
                                        label={`Impact ${impactIndex + 1}`}
                                        rows={2}
                                        value={impact || ''}
                                        onChange={(e) => handleChange(featureIndex, feedbackIndex, impactIndex, 'impact', e.target.value)}

                                    />
                                    <MDBBtn type='button' color="danger" onClick={() => handleChange(featureIndex, feedbackIndex, impactIndex, 'impact', '')} className='mx-2 rounded'>
                                        clear
                                    </MDBBtn>
                                    <MDBBtn className='mx-2'
                                        tag='a'
                                        color='none'
                                        type='button'
                                        onClick={() => removeImpact(featureIndex, feedbackIndex, impactIndex)}
                                    >
                                        <MDBIcon fas icon="times" />
                                    </MDBBtn>



                                </MDBBtnGroup> :
                                 impact &&   <MDBTypography key={impactIndex} note noteColor='primary' className='text-start'>
                                        {impact || ''}
                                    </MDBTypography>
                            ))}
                            {(feedback.isNew || isEdit )&& (
                               
<MDBBtn className='mb-2 mx-5 mt-2' color='warning' onClick={() => addImpact(featureIndex, feedbackIndex)} type='button'>
Add Impact
</MDBBtn>

                            )}
                        </div>
                        <div>


                        <div className='talign-items-center justify-content-center mb-2 mx-0 text-center'>
  <div className='align-items-center justify-content-center mb-2 mx-0 text-center'>
    {tokenLoaded && feedback?.checkboxes && feedback?.checkboxes?.map((checkbox, checkboxIndex) => (
      <div key={checkboxIndex} className='d-flex flex-column flex-md-row align-items-center justify-content-center mb-2 mx-0' style={{ gap: '10px' }}>
        {((tokenLoaded && isEdit) || feedback.isNew) ? (
          <MDBInput
            wrapperClass='flex-grow-1 mb-2 mb-md-0'
            label="Edit Label"
            value={checkbox.label}
            onChange={(e) => handleCheckboxLabelChange(featureIndex, feedbackIndex, checkboxIndex, e.target.value)}
            size="sm"
          />
        ) : (
          <MDBCheckbox
            wrapperClass='mb-2 mb-md-0 text-center'
            label={checkbox.label}
            checked={checkbox.checked}
            onChange={(e) => handleCheckboxChange(featureIndex, feedbackIndex, checkboxIndex, e.target.checked)}
          />
        )}

        {(isEdit || feedback.isNew) && (
          <>
            <MDBCheckbox
              wrapperClass='ms-2 mb-2 mb-md-0'
              label=""
              checked={checkbox.checked}
              onChange={(e) => handleCheckboxChange(featureIndex, feedbackIndex, checkboxIndex, e.target.checked)}
            />
            <MDBBtn
              className='ms-2 mb-2 mb-md-0'
              tag='a'
              color='none'
              onClick={() => removeCheckbox(featureIndex, feedbackIndex, checkboxIndex)}
              type='button'
              style={{ color: '#dd4b39', padding: '0 12px' }}
              disabled={feedback?.checkboxes?.length === 0}
            >
              <MDBIcon fas icon="times-circle" />
            </MDBBtn>
          </>
        )}
      </div>
    ))}

    <div className='align-items-center justify-content-center mb-2 mx-0 text-center'>
      {!tokenLoaded && (
        <table className='table'>
          <thead>
            <tr>
              <th>Question</th>
              <th>Answer</th>
            </tr>
          </thead>
          <tbody>
            {feedback?.checkboxes && feedback?.checkboxes?.map((checkbox, checkboxIndex) => (
              (feedback.isNew || (tokenLoaded && !isEdit)) ? (
                <tr key={checkboxIndex}>
                  <td>{checkbox.label || ''}</td>
                  <td>
                    <MDBCheckbox
                      wrapperClass='ms-2'
                      label=""
                      checked={checkbox.checked}
                      onChange={(e) => handleCheckboxChange(index, feedbackIndex, checkboxIndex, e.target.checked)}
                    />
                  </td>
                </tr>
              ) : (
                <tr key={checkboxIndex}>
                  <td>{checkbox.label || ''}</td>
                  <td>{checkbox.checked ? 'Yes' : 'No'}</td>
                </tr>
              )
            ))}
          </tbody>
        </table>
      )}
    </div>

    {((tokenLoaded && isEdit) || feedback.isNew) && (
      <MDBBtn
        color='primary'
        onClick={() => addCheckbox(featureIndex, feedbackIndex)}
        type='button'
        className='mb-2'
      >
        Add Checkbox
      </MDBBtn>
    )}
  </div>
</div>


                            <div>
                          
                                 {(feedback.isNew || feedback.questions || tokenLoaded) && Array.isArray(feedback.questions) && feedback.questions.map((q, questionIndex) => {
    
    // Determine if this question's category is different from the previous one
    const isNewCategory = questionIndex === 0 || q.category !== feedback.questions[questionIndex - 1].category;

    return (
        <div key={questionIndex} className='mt-1'>
            {/* Render the category heading if it's a new category */}
            {isNewCategory &&(
              ( q.answer || isEdit) && <h3>{q.category}</h3>
            )}
<MDBRow className="align-items-center justify-content-center mb-2">
{(tokenLoaded && isEdit) || (feedback.isNew) ? 
  <MDBCol size="12" md="7" className="mb-2">
    
    
        
        
       <MDBInput title={q?.question ||''}
    className='mb-2'
    label={q?.question || `Question ${questionIndex + 1}`}
    value={q.question}
    onChange={(e) => handleQuestionInputChange(featureIndex, feedbackIndex, questionIndex, 'question', e.target.value)}
/>

            <MDBTextArea    rows={2}
            className='mb-2'
            label={`Answer ${questionIndex + 1}`}
            value={q?.answer || ''}
            onChange={(e) => handleQuestionInputChange(featureIndex, feedbackIndex, questionIndex, 'answer', e.target.value)}
          />
      
   
      
      </MDBCol>
     : <MDBCol size="12" md="12" className="mb-2">
{q?.answer &&
        <MDBTypography note noteColor='primary' className="flex-grow-1 text-start">
          <strong>{q?.question || ''}</strong>
          <p>{q?.answer || ''}</p>
        </MDBTypography>}
  
   
  </MDBCol> }

  {feedback.isNew && <MDBCol size="12" md="2" className="mb-2">
    <MDBSelect
      clearBtn
      autoSelect
      label="Category of Question"
      data={categories}
      value={q?.category || 'DreamState'}
      onValueChange={(selected) => {
        if (selected && selected.value) {
          handleQuestionInputChange(featureIndex, feedbackIndex, questionIndex, 'category', selected.value);
        }
      }}
    />
  </MDBCol> }

  <MDBCol size="12" md="3" className="d-flex justify-content-md-between mb-2">
    {((tokenLoaded && isEdit) || feedback.isNew) && (
      <MDBBtnGroup className="w-100 flex-wrap">
        <MDBBtn
          type='button'
          style={{ color: '#dd4b39', padding: '0 12px' }}
          tag='a'
          color='none'feedbackIndex
          onClick={() => removeQuestion(featureIndex, feedbackIndex, questionIndex)}
        >
          <MDBIcon fas icon="times-circle" />
        </MDBBtn>
        <MDBBtn
          type='button'
          color='info'
          size='sm'
          onClick={() => moveQuestionUp(feedbackIndex, questionIndex)}
          disabled={questionIndex === 0}
        >
          <MDBIcon fas icon="arrow-up" />
        </MDBBtn>
        <MDBBtn
          type='button'
          color='info'
          size='sm'
          onClick={() => moveQuestionDown(feedbackIndex, questionIndex)}
          disabled={questionIndex === feedback.questions.length - 1}
        >
          <MDBIcon fas icon="arrow-down" />
        </MDBBtn>
        <MDBBtn
          type='button'
          color='success'
          size='sm'
          onClick={() => moveQuestionToTop(feedbackIndex, questionIndex)}
          disabled={questionIndex === 0}
        >
          <MDBIcon fas icon="angle-double-up" />
        </MDBBtn>
        <MDBBtn
          type='button'
          color='success'
          size='sm'
          onClick={() => moveQuestionToBottom(feedbackIndex, questionIndex)}
          disabled={questionIndex === feedback.questions.length - 1}
        >
          <MDBIcon fas icon="angle-double-down" />
        </MDBBtn>
      </MDBBtnGroup>
    )}
  </MDBCol>
</MDBRow>


        </div>
    );
})}

    <MDBBtnGroup className='mt-2'>
        <div>
        {((tokenLoaded && isEdit) || feedback.isNew) && <>
                <MDBBtn
                    color="primary"
                    onClick={() => addQuestion(featureIndex, feedbackIndex)}
                    type='button'
                >
                    Add Question
                </MDBBtn>
                 <MDBBtn color="warning" onClick={toggleModal} type='button' >
                 Add New Category
             </MDBBtn>

             </>}

            {((tokenLoaded && isEdit) || feedback.isNew) && (
                <MDBBtn
                    color="danger"
                    type='button'
                    onClick={() => removeFeedback(featureIndex, feedbackIndex)}
                >
                    Remove Feedback
                </MDBBtn>
            )}
        </div>
        {feedback.isNew && (
            <MDBBtn
                type='button'
                className="bg-success text-black bg-opacity-75"
                onClick={(e) => { handleUpdateForNonLoggedinFeedBackUser(demoId, e) }}
            >
                Submit
            </MDBBtn>
        )}
    </MDBBtnGroup>

    <MDBModal open={isModalOpen} setShow={setIsModalOpen}>
        <MDBModalDialog centered>
            <MDBModalContent>
                <MDBModalHeader>
                    <MDBModalTitle>Add New Category</MDBModalTitle>
                    <MDBBtn className="btn-close" color="none" onClick={toggleModal}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>
                    <MDBInput
                        label="Category Name"
                        value={newCategory}
                        onChange={(e) => setNewCategory(e.target.value)}
                    />


                                {/* <MDBInput
                                    type="text"
                                    label="Custom Question"
                                    value={q?.customQuestion || ''}
                                    onChange={(e) => handleQuestionInputChange(index, feedbackIndex, questionIndex, 'customQuestion', e.target.value)}
                                /> */}
                          
                </MDBModalBody>
                <MDBModalFooter>
                    <MDBBtn color="secondary" onClick={toggleModal} type='button'>Close</MDBBtn>
                    <MDBBtn color="primary"  type='button' onClick={handleAddCategory}>Save changes</MDBBtn>
                </MDBModalFooter>
            </MDBModalContent>
        </MDBModalDialog>
    </MDBModal>

</div>

                        </div>
                    </div>
          
                </MDBAccordionItem>
            ))}
        </MDBAccordion>
    );
};

FeedbackAccordion.propTypes = {
    feature: PropTypes.object,
    demoUser: PropTypes.object,
    isEdit: PropTypes.bool,
    index: PropTypes.number,
    featureIndex: PropTypes.number,
    handleChange: PropTypes.func,
    removeImpact: PropTypes.func,
    addImpact: PropTypes.func,
    setActiveAccordions: PropTypes.func,
    addFeedback: PropTypes.func,
    handleCheckboxChange: PropTypes.func,
    addCheckbox: PropTypes.func,
    removeCheckbox: PropTypes.func,
    handleCheckboxLabelChange: PropTypes.func,
    addQuestion: PropTypes.func,
    removeQuestion: PropTypes.func,
    handleQuestionInputChange: PropTypes.func,
    handleAnswerInputChange: PropTypes.func,
    handleFeedbackUserChange: PropTypes.func,
    removeFeedback: PropTypes.func,
    demoId: PropTypes.string,
    handleUpdateForNonLoggedinFeedBackUser: PropTypes.func,
    setCentredModal: PropTypes.func,
    setFormData:PropTypes.object
};

export default FeedbackAccordion;
